import { lazy } from 'react'

const FORCE_REFRESHED_KEY = 'page-force-refreshed'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyWithRetry = (componentImport: any) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      localStorage.getItem(FORCE_REFRESHED_KEY) || 'false',
    )

    try {
      const component = await componentImport()

      localStorage.setItem(FORCE_REFRESHED_KEY, 'false')

      return component
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Refresh the page is user is not on the latest version of the app
        localStorage.setItem(FORCE_REFRESHED_KEY, 'true')
        return location.reload()
      }

      // Throw a normal error if we already tried reloading
      throw error
    }
  })
